import styled from '@emotion/styled';

import Accordion from 'components/global/Accordion';

import { Breakpoints } from 'utils/const.styles';

export const Flex = styled.div`
	display: flex;
	gap: ${({ gap }) => gap ?? '1rem'};
	flex-direction: ${({ direction }) => direction ?? 'row'};
	justify-content: ${({ justify }) => justify ?? 'flex-start'};
	align-items: ${({ align }) => align ?? 'flex-start'};
`;

export const FullWidthAccordion = styled(Accordion)`
	width: 100%;
	margin-block: var(--padding-3);

	.accordion-content-container {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.description-textarea {
		height: auto;
	}
`;

export const FlexAccordion = styled(FullWidthAccordion)`
	.accordion-content-container {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}
`;

export const FullWidth = styled.div`
	width: 100%;
`;

export const Bold = styled.b`
	font-weight: 700;
`;

export const SuccessContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 2rem;
	max-width: 800px;
	margin: 2rem auto;
	gap: var(--spacing-5);
`;

export const LinkContainer = styled.div`
	background: var(--background-1);
	border: 1px solid var(--border-color);
	border-radius: var(--small--border-radius);
	padding: var(--padding-5);
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: var(--spacing-3);
`;

export const PickupOptionsButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const DeliveryCompanyContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 2rem;
	width: 100%;

	@media ${Breakpoints.mobile} {
		grid-template-columns: repeat(1, 1fr);
	}
`;
